import { OperacaoEnum } from "core/resources/enums/conta";
import http from "infra/http";
import { useQuery } from "react-query";
import { CategoriaFinanceiraResponse } from "../typings";

function useGetContasCategorias({
  operacao,
  tenant,
  somenteAtivos,
}: {
  operacao?: OperacaoEnum;
  tenant?: string;
  somenteAtivos?: boolean;
}) {
  return useQuery(
    `/v1/categoria-financeira-${operacao}-${tenant}`,
    async () => {
      const { data } = await http.get<CategoriaFinanceiraResponse[]>(
        `/v1/categoria-financeira`,
        {
          params: {
            operacao,
            tenant,
            somenteAtivos: somenteAtivos ? "1" : undefined,
          },
        }
      );

      return data;
    }
  );
}

export default useGetContasCategorias;
